<template>
  <div class="about-page">
    <header-menu curPage="about"></header-menu>

    <!-- 顶部蓝色背景区域 -->
    <div class="hero-section">
      <div class="hero-content">
        <h1>成为全球领先的移动广告变现平台，构建健康、高效的广告生态</h1>
        <p>让每一次点击，都转化价值</p>
        <button class="register-btn" @click="goToAdmin">立即注册</button>
      </div>
    </div>

    <!-- 我们的业务部分 -->
    <div class="business-section">
      <h2>我们的业务</h2>
      <p class="business-desc">KBmob轻量高效流量变现平台，聚焦破解开发者变现效率低、广告预算单一的核心痛点，以优质广告资源、自研技术擎、定制化服务为三大核心支撑，助力开发者实现收益最大化与长效增长。</p>
      <div class="business-images">
        <div class="business-image-item">
          <img src="../../public/pic_about_1@2x.png" alt="业务图片1" />
        </div>
        <div class="business-image-item">
          <img src="../../public/pic_about_2@2x.png" alt="业务图片2" />
        </div>
      </div>
    </div>

    <!-- 我们的团队部分 -->
    <div class="team-section">
      <h2>我们的团队</h2>
      <p class="team-desc">我们的核心团队来自头部广告公司、互联网企业，拥有10年+广告变现、算法研发、运营服务经验，深刻理解开发者与广告主需求。</p>
      <div class="team-images">
        <div class="team-image-item">
          <img src="../../public/pic_about_3@2x.png" alt="团队图片1" />
        </div>
        <div class="team-image-item">
          <img src="../../public/pic_about_4@2x.png" alt="团队图片2" />
        </div>
      </div>
    </div>

    <!-- 我们的品牌部分 -->
    <div class="brand-section">
      <h2>我们的品牌</h2>
      <p class="brand-desc">KBmob 名称巧妙融合 “功能” 与 “链接” 双重含义，既体现平台的技术专业性，又彰显其连接价值。作为智能广告平台，Funlink通过三大核心价值赋能开发者：</p>
      <div class="brand-values">
        <div class="brand-value-item">
          <div class="brand-title">智信融合</div>
          <p>整合各方资源链接，实现广告流量的最优化配置。</p>
        </div>
        <div class="brand-value-item">
          <div class="brand-title">数据驱动</div>
          <p>通过海量数据洞察与分析，保障投放效果精准转化。</p>
        </div>
        <div class="brand-value-item">
          <div class="brand-title">生态协同</div>
          <p>以AI为核心技术引擎构建广告产品生态，形成闭环服务能力，技术创新引领行业未来。</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import HeaderMenu from '../components/header-menu.vue';
export default {
  name: 'about',
  components: {
    HeaderMenu
  },
  data() {
    return {}
  },
  methods: {
    // 可以在这里添加注册按钮的点击事件处理
    goToAdmin() {
      window.open('https://admin.kuaibian.top/register');
    }
  }

}
</script>

<style scoped>
.about-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* 顶部蓝色背景区域 */
.hero-section {
  color: white;
  padding: 80px 0;
  height: 360px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('../../public/banner_3@2x.png');
  background-size: cover;
  background-position: center;
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.hero-content h1 {
  font-size: 32px;
  margin-bottom: 24px;
  font-weight: bold;
  line-height: 1.3;
}

.hero-content p {
  font-size: 18px;
  margin-bottom: 40px;
  opacity: 0.9;
}

.register-btn {
  background: #10D294;
  color: white;
  border: none;
  padding: 14px 28px;
  font-size: 18px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.register-btn:hover {
  background-color: #45a049;
}

/* 我们的业务部分 */
.business-section {
  padding: 60px 0;
  text-align: center;
}

.business-section h2 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

.business-desc {
  max-width: 1000px;
  margin: 0 auto 40px;
  padding: 0 20px;
  color: #8C8C8C;
  line-height: 1.6;
}

.business-images {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}

.business-image-item {
  flex: 1;
  min-width: 300px;
  max-width: 450px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.business-image-item img {
  width: 100%;
  height: auto;
  display: block;
}

/* 我们的团队部分 */
.team-section {
  padding: 60px 0;
  text-align: center;
}

.team-section h2 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

.team-desc {
  max-width: 1200px;
  margin: 0 auto 40px;
  padding: 0 20px;
  color: #8C8C8C;
  line-height: 1.6;
}

.team-images {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin: 0 auto;
}

.team-image-item {
  flex: 1;
  min-width: 300px;
  max-width: 450px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.team-image-item img {
  width: 100%;
  height: auto;
  display: block;
}

/* 我们的品牌部分 */
.brand-section {
  padding: 60px 0;
  text-align: left;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px;
}

.brand-section h2 {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
}

.brand-desc {
  max-width: 1200px;
  margin: 0 0 40px;
  color: #8C8C8C;
  font-size: 15px;
  line-height: 1.6;
}

.brand-values {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1200px;
  margin: 0;
  padding: 0;
}

.brand-value-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.brand-title {
  width: 130px;
  height: 32px;
  background-color: #E7FAF4;
  color: #10D294;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
  border-radius: 4px;
}

.brand-value-item p {
  flex: 1;
  color: #666;
  line-height: 32px;
  font-size: 14px;
  justify-content: center;
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 24px;
  }

  .business-images,
  .team-images,
  .brand-values {
    flex-direction: column;
    align-items: center;
  }

  .business-image-item,
  .team-image-item,
  .brand-value-item {
    width: 90%;
    max-width: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/About.vue